document.querySelectorAll<HTMLFormElement>('.contact-form').forEach(form => {
	const status = form.querySelector('.status')!

	form.addEventListener('submit', async e => {
		e.preventDefault()

		const token = await window.grecaptcha.execute(
			'6LdpxWYrAAAAAGkJsvIMuadSD7s1yfY3L2thmGDi',
			{
				action: 'submit',
			}
		)

		const formData = new FormData(form)

		formData.set('g-recaptcha-response', token)

		const action = form.getAttribute('action')
		if (action) {
			const formspreeResponse = await fetch(action, {
				method: 'POST',
				headers: { Accept: 'application/json' },
				body: formData,
			})

			const data = await formspreeResponse.json()

			if (Object.hasOwn(data, 'errors')) {
				status.textContent = data.errors
					.map((err: { message: string }) => err.message)
					.join(', ')
			} else {
				status.textContent = "Thank's for your message!"
				form.reset()

				if (window.dataLayer) {
					window.dataLayer.push({ event: 'contact_form_submit' })
				}
			}
		}
	})
})
